/// <reference path="../appDashboard.ts" />

var managerActivityStructure = function () {
    return {
        restrict : 'E',
        replace: false,
        scope: {
            promiseUserPopulated: '=',
            promiseCommercialCalendar: '=',
        },
        controller : 'DashboardManagerActivityStructureController as dashboardManagerActivityStructureController',
        templateUrl : '/templates/manager-activity-structure.html',
    };
};

appDashboard.directive("managerActivityStructure", [managerActivityStructure]);
